import React__default from 'react';

var NavLinkButton = function (props) {
    var className = props.className, onClick = props.onClick, link = props.link, children = props.children;
    var handleClick = function (event) {
        event.preventDefault();
        onClick(link);
    };
    return (React__default.createElement("button", { className: className, onClick: handleClick, name: link.buttonName || link.displayName, role: "link" }, children));
};
NavLinkButton.displayName = 'NavLink';

export { NavLinkButton };
